import { Dialog, DialogContent, Button } from '@sib/ui';
import { X } from '@sib/ui/icons';
import { useAskAiUrl } from './AskAiModal.utils';

interface AskAiModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

export const AskAiModal = ({ isOpen, onClose, title }: AskAiModalProps) => {
  const { isAiEnabled, askAiUrl } = useAskAiUrl();

  if (!isAiEnabled || !askAiUrl) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="h-[90vh] max-w-[90vw]">
        <div className="absolute top-4 right-4 z-10">
          <Button
            onClick={onClose}
            variant="ghost"
            size="sm"
            data-testid="ask-ai-modal-close"
          >
            <X className="size-4" />
          </Button>
        </div>
        <iframe
          src={askAiUrl}
          className="h-full w-full rounded-lg border-0"
          title={title}
          allow="clipboard-read; clipboard-write; microphone"
        />
      </DialogContent>
    </Dialog>
  );
};
